/**
 * Número em pt-BR, como o protótipo o escreve: `1.608`, `91.393,3`, `0,0`.
 *
 * Arquivo próprio, e não dentro de `componentes.tsx`, porque um módulo que
 * exporta componente **e** função quebra o recarregamento rápido do Vite — é o
 * que o `react-refresh/only-export-components` avisa.
 *
 * Fica aqui, e não em `nucleo/formato/`, porque `nucleo/` pertence a outro alvo
 * — a regra de propriedade de arquivo de `docs/ALVOS.md`. Quando um segundo
 * módulo precisar do mesmo, é hora de promovê-lo.
 */

const INTEIRO = new Intl.NumberFormat('pt-BR', { maximumFractionDigits: 0 });

const UMA_CASA = new Intl.NumberFormat('pt-BR', {
  minimumFractionDigits: 1,
  maximumFractionDigits: 1,
});

export function formatarInteiro(valor: number): string {
  return INTEIRO.format(valor);
}

export function formatarDecimal(valor: number): string {
  return UMA_CASA.format(valor);
}
